export const isWeekend = [0, 6, 7].includes(new Date().getUTCDay());